import React from 'react'
import classNames from "classnames";
import AjaxButton from "../../../../form/ajax_button";
import {useSelector} from "react-redux";
import {timeDayToDisplayTimeslot} from "./utils";


export default function MeetingTimeslotsConfirmModal({selectedTimeslots, onClose, onUpdated, onUpdateStarted}) {
  const meetingConfirmUrl = useSelector(state => state.meetingConfirmUrl)

  const groupTimeslotsByDay = _.chain(selectedTimeslots)
    .groupBy("day")
    .sortBy((value, key) => key)
    .value()

  return <div className="modal preview-modal"
              onClick={onClose}
              id="modal"
              role="dialog"
              tabIndex="-1"
              style={{"display": "inline"}}>
    <div className="modal-dialog"
         onClick={(e) => e.stopPropagation()}
         role="document"
         style={{maxWidth: "50vh"}}>
      <div className="modal-content">
        <div className="modal-header" style={{backgroundColor: "transparent"}}>
          <button
            style={{padding: "0.5rem"}}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={onClose}>
            <i className="fal fa-times-circle"/>
          </button>
        </div>
        <div className="modal-body" style={{maxHeight: "80vh"}}>
          <p>You are about to confirm the following time slots:</p>
            {groupTimeslotsByDay.map((group, key) => <div key={key}>
              <hr/>
              <strong>{group[0].day}. October</strong>
              <ul>
                {_.sortBy(group, "hour").map((timeslot) => <li key={timeslot.hour}>
                  {timeDayToDisplayTimeslot(timeslot.hour, timeslot.day)}
                </li>)}
              </ul>
            </div>)}
        </div>
        <div className={classNames("modal-footer")}>
          <AjaxButton
            method={"post"}
            label={"Confirm"}
            labelSending={"Confirming ..."}
            className={classNames("btn btn-sm btn-success")}
            icon={"fa-save"}
            url={meetingConfirmUrl}
            data={{
              timeslots: selectedTimeslots
            }}
            onSuccess={(data) => {
              if (data.data.status === "OK") {
                onUpdated(data.data.confirmedTimeslots)
                onClose()
              } else {
                alert(data.data.message || "A error occurred while confirming your timeslots.")
              }
            }}
            onError={(error) => {
              console.log(error)
              alert("Error while confirming timeslots", error)
            }}
          />
        </div>
      </div>
    </div>
  </div>
}
